/**
 * Local-only flag: when true, the CRM sync outbox does NOT auto-flush on online/visibility.
 * Instead, items stay pending until the user manually approves them via the indicator UI.
 */
const KEY = "tpt-crm-offline-sync-require-review";

export function getOfflineSyncRequireReview(): boolean {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

export function setOfflineSyncRequireReview(value: boolean): void {
  try {
    if (value) {
      localStorage.setItem(KEY, "1");
    } else {
      localStorage.removeItem(KEY);
    }
  } catch {
    /* non-critical */
  }
}
